"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateComparisons = exports.formatDayJS = exports.getModifedTime = exports.decimalMinutesToTimeString = void 0;
const tslib_1 = require("tslib");
const dayjs_1 = tslib_1.__importDefault(require("dayjs"));
const customParseFormat_1 = tslib_1.__importDefault(require("dayjs/plugin/customParseFormat"));
dayjs_1.default.extend(customParseFormat_1.default);
const decimalMinutesToTimeString = (decimalMinutes, formatType = 'words', includeSeconds = false) => {
    const hours = Math.floor(decimalMinutes / 60);
    const minutes = Math.floor(decimalMinutes - hours * 60);
    const seconds = Math.round((decimalMinutes - Math.floor(decimalMinutes)) * 60);
    let timeString = ``;
    if (formatType == 'clock')
        timeString = `${hours > 0 ? hours + ':' : ''}${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    if (formatType == 'words') {
        timeString += `${hours > 0 ? hours + 'hr ' : ''}${minutes < 10 ? '0' : ''}${minutes}m`;
        if (includeSeconds)
            timeString += ` ${seconds < 10 ? '0' : ''}${seconds}s`;
    }
    return timeString;
};
exports.decimalMinutesToTimeString = decimalMinutesToTimeString;
/**
 *
 * @param start
 * @param duration in minutes
 * @param format
 * @returns
 */
const getModifedTime = (start, duration, format) => {
    let formatType = `hh:mm ${start.includes('AM') || start.includes('PM') ? 'A' : ''}`;
    const newTime = (0, dayjs_1.default)(start, formatType)[format](duration, 'minute');
    return newTime;
};
exports.getModifedTime = getModifedTime;
const formatDayJS = (day, showAP = false) => {
    return day.format(`${showAP ? 'hh:mm A' : 'HH:mm'}`);
};
exports.formatDayJS = formatDayJS;
const checkSameDay = (ts1, ts2, locale = 'en-NZ') => {
    return new Date(ts1).toLocaleDateString(locale) === new Date(ts2).toLocaleDateString(locale);
};
const checkSameYear = (ts1, ts2) => {
    return new Date(ts1).getFullYear() === new Date(ts2).getFullYear();
};
const checkSameMonth = (ts1, ts2) => {
    return new Date(ts1).getMonth() === new Date(ts2).getMonth() && checkSameYear(ts1, ts2);
};
exports.DateComparisons = { checkSameDay, checkSameMonth, checkSameYear };
